import React from "react";
import T from "prop-types";
import { connect } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { Field, formValueSelector } from "redux-form";
import {
  Check,
  CheckGroup,
  form,
  Form as AppForm,
  RadioGroupField
} from "MODULES/shared/components/Forms";
import * as actions from "MODULES/inventories/actions";
import {
  CREDIT_REQUESTED,
  PARTIAL_CREDIT_AMT,
  REASONS
} from "MODULES/RMAsAndWarranties/constants";
import {
  PARTIAL_CREDIT,
  PARTIAL_CREDIT_AMOUNT,
  RMA_REQUEST_TYPE,
  WARRANTY_CONSIDERATION
} from "MODULES/RepairOrders/constants";
import { SHIPPING_TYPE } from "APP_ROOT/constants";
import { properCase } from "LIB/formatters/text";
import CurrencyField from "MODULES/shared/components/Forms/CurrencyField";
import { toOptions } from "LIB/forms";
import { Select } from "MODULES/shared/components/Forms/Select/Select";
import { REASON } from "MODULES/SalesOrders/constants";
import validate from "./validate";

export function Form(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <Row>
          <Col md={6}>
            <Field
              name={RMA_REQUEST_TYPE}
              label="Request Type"
              component={RadioGroupField}
              options={[
                {
                  value: "rma",
                  text: "Request RMA"
                },
                { value: PARTIAL_CREDIT, text: "Request Partial Credit" }
              ]}
            />
          </Col>
          <Col md={6}>
            <label className="control-label" htmlFor={REASON}>
              Reason
            </label>
            <Field
              name="reason"
              component={Select}
              label="Reason"
              options={toOptions(REASONS)}
              required
            />
          </Col>
        </Row>
        {!props.managedRepair && (
          <Row>
            <Col md={6}>
              <CheckGroup title="Request Credit" justified>
                <Field
                  name={CREDIT_REQUESTED}
                  component={Check}
                  label="Credit Requested"
                />
              </CheckGroup>
            </Col>
            <Col md={6}>
              <CheckGroup title={properCase(WARRANTY_CONSIDERATION)} justified>
                <Field
                  name={WARRANTY_CONSIDERATION}
                  component={Check}
                  label={properCase(WARRANTY_CONSIDERATION)}
                />
              </CheckGroup>
            </Col>
          </Row>
        )}
        {props.rmaRequestType === PARTIAL_CREDIT && (
          <Row>
            <Col md={6}>
              <Field
                component={CurrencyField}
                name={PARTIAL_CREDIT_AMT}
                label={properCase(PARTIAL_CREDIT_AMOUNT)}
              />
            </Col>
          </Row>
        )}
      </AppForm.Body>
    </AppForm>
  );
}

const FORM_NAME = "createVendorRmaForm";

const selector = formValueSelector(FORM_NAME);

Form.propTypes = {
  managedRepair: T.bool,
  props: T.shape({}).isRequired
};

export default connect(
  state => ({
    shippingType: selector(state, SHIPPING_TYPE),
    rmaRequestType: selector(state, RMA_REQUEST_TYPE)
  }),
  dispatch => ({
    onSubmit: data => dispatch(actions.createVendorRma(data))
  })
)(
  form({
    form: FORM_NAME,
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/CreateVendorRma/Form.jsx